export class Config {
    public static readonly API_URL = "https://cc.bbold.vn/";
    public static readonly OPENWEATHER_API_KEY = "6e9c76094395eccb9b81153767e41526";
    public static saturdayOff = new Date(2023, 4, 1);
}